import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=e048999e&scoped=true&"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=e048999e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e048999e",
  null
  
)

export default component.exports